import { tv } from "tailwind-variants";

import type { IconType } from "./icons";

const inputLeftIconVariants = tv({
  base: "size-4 fill-current",
  variants: {
    hasError: {
      true: "text-danger",
      false: "text-content-subtle",
    },
  },
});

export const InputLeftIcon = (hasError: boolean, Icon: IconType) => {
  return <Icon className={inputLeftIconVariants({ hasError })} />;
};
